import React from 'react';
import { Wallet, ArrowRightLeft, ExternalLink } from 'lucide-react';
import siteConfig from '../config/contentConfig';
import { Button } from './ui/button';

const HowToBuy = () => {
  const iconMap = {
    wallet: Wallet,
    swap: ArrowRightLeft,
  };

  return (
    <section
      id="how-to-buy"
      data-testid="how-to-buy-section"
      className="section-container bg-[#0C0E12]"
    >
      <div className="text-center space-y-4 mb-16">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
          How to Buy{' '}
          <span className="text-[#32B44A]">{siteConfig.token.symbol}</span>
        </h2>
        <div className="w-24 h-1 bg-[#FFD600] mx-auto rounded-full" />
        <p className="text-slate-300 max-w-3xl mx-auto text-lg">
          Follow these simple steps to get your hands on some $NANA tokens and join the most exciting memecoin community on Supra!
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
        {siteConfig.howToBuy.map((step) => {
          const Icon = iconMap[step.icon];
          return (
            <div
              key={step.step}
              data-testid={`step-card-${step.step}`}
              className="glass rounded-2xl p-8 card-hover border border-yellow-500/20 relative overflow-hidden"
            >
              {/* Step Number Circle */}
              <div className="absolute top-6 right-6 w-12 h-12 rounded-full bg-gradient-to-br from-[#FFD600] to-[#32B44A] flex items-center justify-center">
                <span className="text-xl font-black text-black">{step.step}</span>
              </div>

              {/* Icon */}
              <div className="w-16 h-16 rounded-xl bg-[#FFD600]/20 flex items-center justify-center mb-6">
                <Icon size={32} className="text-[#FFD600]" />
              </div>

              {/* Content */}
              <h3 className="text-xl sm:text-2xl font-bold mb-4 pr-16">
                {step.title}
              </h3>
              <p className="text-slate-300 mb-6">{step.description}</p>

              {/* CTA - Single Button or Multiple Buttons */}
              {step.buttons ? (
                // Multiple buttons for Step 2 (Dexlyn & Atmos)
                <div className="flex flex-col sm:flex-row gap-3">
                  {step.buttons.map((button, index) => (
                    <Button
                      key={index}
                      data-testid={`step-cta-${button.label.toLowerCase().replace(' ', '-')}`}
                      onClick={() => window.open(button.link, '_blank')}
                      className="bg-[#32B44A] hover:bg-[#28A745] text-white font-bold btn-press flex-1"
                    >
                      {button.label}
                      <ExternalLink size={16} className="ml-2" />
                    </Button>
                  ))}
                </div>
              ) : (
                // Single button for Step 1 (Wallet)
                <Button
                  data-testid={`step-cta-${step.step === 1 ? 'wallet' : 'swap'}`}
                  onClick={() => window.open(step.ctaLink, '_blank')}
                  className="bg-[#32B44A] hover:bg-[#28A745] text-white font-bold btn-press w-full"
                >
                  {step.cta}
                  <ExternalLink size={16} className="ml-2" />
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HowToBuy;
